import type { AuthRuntime } from '@srm/core/auth';
import type { ApiPlugin } from '@srm/core/http';

/** Вход, выход, ротация и SAML — запросы обычной сессии браузера. */
const SESSION_REQUEST = /\/(?:Account\/(?:SignIn(?:ByHeader)?|SignOut)|RefreshToken|Saml)(?:[/?]|$)/i;

export const SUPPORT_SIGN_IN_BLOCKED_MESSAGE = 'Обычный вход недоступен во вкладке поддержки.';

/**
 * Вкладка «от имени» (изолированный вход сеанса поддержки): обычные вход, выход, ротация и SAML отсюда не уходят —
 * они записали бы или сняли сессию пользователя этого браузера. Запрос отменяется (`CanceledError`).
 */
export const supportSessionGuardPlugin = (session: Pick<AuthRuntime, 'isIsolated'>): ApiPlugin => ({
    name: 'support-session-guard',
    request: ({ url }) =>
        session.isIsolated() && SESSION_REQUEST.test(url ?? '') ? SUPPORT_SIGN_IN_BLOCKED_MESSAGE : undefined,
});
